// What /app/signed-in tells a browser that lands there outside the iOS app
// (TOM-555, ADR 0350). The Google callback ends the app's sign-in there with the
// outcome in the URL fragment: `code` and `state`, or `error` (and `email` for an
// identity_conflict) and `state`. The app's ASWebAuthenticationSession normally
// catches the URL before the page loads.

export type AppSignInOutcome = 'signed_in' | 'identity_conflict' | 'failed';

/** The outcome a fragment carries. Never the code or the address themselves. */
export function appSignInOutcome(hash: string): AppSignInOutcome {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  if ((params.get('code') ?? '').length > 0) return 'signed_in';
  if (params.get('error') === 'identity_conflict') return 'identity_conflict';
  return 'failed';
}
